/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import _ from 'lodash';
import React, { createContext } from 'react';

import { useQuickSetup } from '../../../hooks/useQuickSetupContext';
import { QuickSetup } from './QuickSetup';

interface QuickSetupProviderProps {
  title?: string;
  icon?: any;
  buttonHooks: {
    nextClicked?: number;
    backClicked?: number;
    setEnableNext?: (enable: boolean) => void;
    setEnableBack?: (enable: boolean) => void;
    setFinished?: (finish: boolean) => void;
    setShowBack?: (show: boolean) => void;
    setShowNext?: (show: boolean) => void;
  };
  readOnly?: boolean;
}

const QuickSetupContext = createContext({
  clearSteps: () => {},
  markStepComplete: (_complete: boolean) => {},
  setStepFilter: (_step: string) => {},
  readOnly: false,
  steps: [],
  setSteps: (_steps: any[]) => {},
  currentStep: 0,
  setCurrentStep: (_step: number) => {},
  shouldDisableStep: (_step: number) => false,
  filteredSteps: [],
  setFilteredSteps: (_steps: any[]) => {}
});

const QuickSetupProvider: React.FC<QuickSetupProviderProps> = props => {
  const quickSetupContext = useQuickSetup(
    { ...props.buttonHooks, readOnly: props.readOnly } ?? {}
  );
  return (
    <QuickSetupContext.Provider value={{ ...quickSetupContext }}>
      <QuickSetup {..._.omit(props, ['buttonHooks', 'readOnly', 'children'])}>
        {props.children}
      </QuickSetup>
    </QuickSetupContext.Provider>
  );
};

export { QuickSetupProvider, QuickSetupContext };
